import { createGlobalStyle } from 'styled-components'
import { palette } from 'configureBrand'
import { colors } from 'const/colors'

/*
 *createGlobalStyles replaces index.css.
 *It's more flexible and consistent with our usage of styled components.
 *Learn more about it here: https://www.styled-components.com/docs/api#createglobalstyle
 */
const { primary } = palette

export default createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
    color: #303941;
    font-family: "Open Sans", serif;
    font-size: 14px;
    font-weight: 400;
    background-color: #f1f2f4;
  }

  * {
    box-sizing: border-box;
  }

  /* Consistent resizing of superscript relative to surrounding font size*/
  sup {
    font-size: 0.625em;
  }

  div[data-test="text-field-wrapper"] {
    box-sizing: content-box;
  }

  div[data-test="text-field-wrapper"] + div {
    flex-direction: row;
  }

  .checkbox input:focus {
    clip: rect(0 0 0 0);
  }

  div.checkbox input:checked + div {
    border: 2px solid ${primary} !important;
  }

  div.checkbox label > div:first-child {
    margin-left: 0;
  }

  /* TODO: remove after upgrading to v1.6.0 of SYF CL which adds outline to checkbox */
  div.checkbox label > div:first-child > input[type="checkbox"]:focus + div {
    outline: 1px solid ${primary};
  }

  @media print {
    body * {
      visibility: hidden;
    }
  }

  button{
    display:-webkit-box;
  }

  /**
  * We need to override the background-color of the salected day because react-datepicker 
  * applies ##1d5d90 across all months in the selected day.
  *
  * Example: if selected day is oct 20, all other days will have grey hover
  * but nov 20 (and all other months in same day) will have the #1d5d90 background-color when hovered.
  *
  * Error is in react-datepicker:
  * https://github.com/Hacker0x01/react-datepicker/issues/2930
  */
  .react-datepicker__day--keyboard-selected:hover{
    &:hover{
      background-color: ${colors.datepickerSelectedDayHover};
    }
  }
`
